import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation, useParams } from "react-router";
import { useDocumentTitle } from "../hooks/useDocumentTitle";
import { useRootStore } from "../store/contexts/RootStoreContext";
import { useGlobalKeyboardShortcuts } from "../common/hooks/useGlobalKeyboardShortcuts";
import { NavigationGuard } from "../components/NavigationGuard";

export function RouterSync() {
  const rootStore = useRootStore();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const hasValidated = useRef(false);

  useEffect(() => {
    rootStore.router.updateFromReactRouter(
      params,
      location.pathname,
      location.search,
      navigate
    );

    if (!hasValidated.current) {
      rootStore.validateAndSyncBreadcrumbs(location.pathname);
      hasValidated.current = true;
    }
  }, [rootStore, navigate, location, params]);

  useDocumentTitle();
  useGlobalKeyboardShortcuts();

  // NavigationGuard envuelve Outlet y maneja bloqueo de navegación centralizado
  return <NavigationGuard />;
}
